<template>
    <li class="dropdown-color-item" @click.stop="$emit('select', value)">
        <a href="#" :class="{ selected: selected }">
            <font-awesome-icon v-if="value.text" :icon="value.text" class="icon fa-lg" />
            <span :class="{ selected: selected }">{{ value.text }}</span>
        </a>
    </li>
</template>

<script>
export default {
    // name: 'select-item-icon',
    props: ['value', 'selected', 'mark'],
    data() {
        return {};
    },
};
</script>

<style lang="scss">
li.dropdown-color-item {
    padding: 5px 20px;

    > a {
        // position: relative;
        white-space: nowrap;
        color: #9ca5b0;
        font-size: 13px;
        line-height: 13px;
        transition: color 0.25s ease;
        font-weight: 500;
        // padding: 7px 9px;
        // padding-top: 7px;
        // outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        text-decoration: none;

        background: none;
        background-color: transparent;

        &.selected {
            // color: #3b3e47;
            color: #151b25;
        }

        span {
            vertical-align: middle;

            &.color-pill {
                border-radius: 50%;
                width: 18px;
                height: 18px;
                align-self: center;
                display: inline-block;
                margin-right: 9px;
            }
        }
    }

    &:hover > a {
        color: #3b3e47;
    }
}
</style>
